import { Menu } from 'antd';
import * as React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { StyledMenu } from '../StyledSidebarComponent';

export interface ILinkMenuProps {
  linkPath: string;
  icon: JSX.Element;
  title: string;
}

export const LinkMenu = ({ linkPath, icon, title, ...props }: ILinkMenuProps) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const onKeyDown = () => {
    navigate(linkPath);
  };

  return (
    <StyledMenu theme="dark" selectable={false} selectedKeys={pathname.includes(linkPath) ? [linkPath] : []}>
      <Menu.Item tabIndex={0} key={linkPath} {...props} onKeyDown={(e) => e.key === 'Enter' && onKeyDown()}>
        {icon}
        <span>{title}</span>
        <Link tabIndex={-1} to={linkPath}>
          <span className="sr-only">{title}</span>
        </Link>
      </Menu.Item>
    </StyledMenu>
  );
};
